import { useEffect } from "react";
import { RiWhatsappFill } from "react-icons/ri";
import { HeaderTopPublic } from './Views/Web/_UI/HeaderTopPublic';
import { SiteDevelopmentViewMain } from "./Views/Web/Public/SiteDevelopmentViewMain.js";

import "./Views/LoopyStudiosStyles.css"

// --------------------------------- 🔥 LIBS
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'bootstrap/dist/css/bootstrap.min.css';

const WHATSAPP_NUMBER = "5493446509325";
const WHATSAPP_MESSAGE = "¡Hola! Quiero llevar adelante un proyecto con Loopy Studios. ¿Me ayudan con un presupuesto?";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function App() {

  const currentYear = new Date().getFullYear();
  const startYear = 2026;
  const displayYear = currentYear === startYear ? startYear : `${startYear} — ${currentYear}`;

  // 🎯 Scroll top por cada desplazamiento de ruta
  useEffect(() => {
    // 1. Forzar el scroll al inicio inmediatamente
    window.scrollTo(0, 0);

    // 2. Truco extra: Desactivar la restauración automática del scroll del navegador
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Opcional: Si tienes imágenes pesadas o contenido que tarda en renderizar
    const handleLoad = () => window.scrollTo(0, 0);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('load', handleLoad);
      // Volver a ponerlo en auto al salir si es necesario
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  const onClickScrollToSection = (id) => {
    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // al ser landing redireccionamos a la home y limpiamos url oara que no quede residuos
  useEffect(() => {
    // Verificamos si hay algo después del dominio (path) o parámetros (?query)
    if (window.location.pathname !== '/' || window.location.search !== '') {

      // Reemplazamos el estado del historial para que la URL quede limpia
      window.history.replaceState(null, '', '/');

      // Opcional: Si quieres ver en consola que se limpió
      // console.log("URL limpiada: Redirigido a Home");
    }
  }, []);


  return (
    <div className="LOOPY_STUDIOS__web_container">
      <HeaderTopPublic onClickScrollToSection={onClickScrollToSection} />

      <a href={WHATSAPP_LINK} className={`app_whatsapp_btn visible }`}
        target="_blank" rel="noopener noreferrer" style={{
          display: 'flex',
        }} >
        <RiWhatsappFill color='#ffffffff' />
      </a>

      <div className="ls__content_services">
        <SiteDevelopmentViewMain />
      </div>

      <footer className="site-development-footer-copyright">
        <div className="footer-line"></div>
        <p>
          &copy; {displayYear} <span>Loopy Studios</span>.
          Todos los derechos reservados.
        </p>
        <div className="footer-tag">LOOPY STUDIOS V.1.0</div>
      </footer>
    </div>
  );
}

export default App;